import { createTheme } from "@mui/material/styles";

const THEME = createTheme({
    typography: {
        fontFamily: ["Arial", "Roboto"].join(","),
    },
});

export default THEME;
